package com.daytimegaming.ourdailyfinances.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.PreviewLightDark
import androidx.compose.ui.unit.dp
import com.daytimegaming.ourdailyfinances.presentation.theme.AppTheme

@Composable
fun GradientScreenBackground(
    content: @Composable () -> Unit,
) {
    Box(
        Modifier
            .fillMaxSize()
            .size(600.dp)
            .meshGradient(
                points = listOf(
                    listOf(
                        Offset(0f, 0f) to MaterialTheme.colorScheme.primary,
                        Offset(.5f, 0f) to MaterialTheme.colorScheme.primary,
                        Offset(1f, 0f) to MaterialTheme.colorScheme.primary,
                    ),
                    listOf(
                        Offset(0f, .5f) to MaterialTheme.colorScheme.background,
                        Offset(.3f, .8f) to MaterialTheme.colorScheme.background,
                        Offset(1f, .5f) to MaterialTheme.colorScheme.background,
                    ),
                    listOf(
                        Offset(0f, 1f) to MaterialTheme.colorScheme.primaryContainer,
                        Offset(.2f, 1f) to MaterialTheme.colorScheme.primaryContainer,
                        Offset(1f, 1f) to MaterialTheme.colorScheme.primaryContainer,
                    ),
                ),
                resolutionX = 1,
            )
    ) {
        content()
    }
}

@Composable
fun LandingScreenBackground(
    content: @Composable () -> Unit,
) {
    val backgroundColor = Color(0xFF0E1513)
    val tealColor = Color(0xFF57F1DB)
    val topLeftTeal = tealColor.copy(alpha = 0.05f)
    val bottomRightTeal = tealColor.copy(alpha = 0.03f)

    Box(
        Modifier
            .fillMaxSize()
            .background(backgroundColor)
            .meshGradient(
                points = listOf(
                    listOf(
                        Offset(0f, 0f) to topLeftTeal,
                        Offset(.5f, 0f) to backgroundColor,
                        Offset(1f, 0f) to backgroundColor,
                    ),
                    listOf(
                        Offset(0f, .5f) to backgroundColor,
                        Offset(.5f, .5f) to backgroundColor,
                        Offset(1f, .5f) to backgroundColor,
                    ),
                    listOf(
                        Offset(0f, 1f) to backgroundColor,
                        Offset(.5f, 1f) to backgroundColor,
                        Offset(1f, 1f) to bottomRightTeal,
                    ),
                ),
                resolutionX = 1,
            )
    ) {
        content()
    }
}

@PreviewLightDark
@Composable
private fun PreviewGradientScreenBackground() {
    AppTheme(
        darkTheme = isSystemInDarkTheme(),
        dynamicColor = false,
    ) {
        Surface {
            GradientScreenBackground {  }
        }
    }
}

@PreviewLightDark
@Composable
private fun PreviewLandingScreenBackground() {
    AppTheme(
        darkTheme = isSystemInDarkTheme(),
        dynamicColor = false,
    ) {
        Surface {
            LandingScreenBackground {  }
        }
    }
}
